import { render, staticRenderFns } from "./pwa_social.vue?vue&type=template&id=652a6b28&scoped=true&"
import script from "./pwa_social.vue?vue&type=script&lang=js&"
export * from "./pwa_social.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a6b28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('652a6b28')) {
      api.createRecord('652a6b28', component.options)
    } else {
      api.reload('652a6b28', component.options)
    }
    module.hot.accept("./pwa_social.vue?vue&type=template&id=652a6b28&scoped=true&", function () {
      api.rerender('652a6b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/social/pwa_social.vue"
export default component.exports